// -----------------------------------------------------------------
// frontend/src/main.jsx — ponto de entrada do React + Vite
// -----------------------------------------------------------------
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

const PRELOAD_RECOVERY_KEY = 'remote-admin:preload-recovery';
const PRELOAD_RECOVERY_WINDOW_MS = 15_000;

// After a deploy, an open tab can still reference chunks from the previous build.
// Reload once so the browser receives the current index and its asset manifest.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();

  const now = Date.now();
  const lastRecovery = Number(sessionStorage.getItem(PRELOAD_RECOVERY_KEY) || 0);
  if (now - lastRecovery < PRELOAD_RECOVERY_WINDOW_MS) return;

  sessionStorage.setItem(PRELOAD_RECOVERY_KEY, String(now));
  window.location.reload();
});

// <React.StrictMode> ajuda a identificar efeitos colaterais
// duplicados e outros problemas em ambiente de desenvolvimento.
// <BrowserRouter> garante que TODA a árvore — inclusive Login —
// tenha acesso ao roteador (history, Link, Navigate, etc.).
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
